// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__qtq2l","Cards-wrapper":"Cards_Cards-wrapper__HgWgU","card":"Cards_card__qnHgt","icon-wrapper":"Cards_icon-wrapper__W29uw"};